
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
/*!
 * Mmenu Light
 * mmenujs.com/mmenu-light
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-4.0
 * http://creativecommons.org/licenses/by/4.0/
 */
:root {
  --mm-ocd-width: 90%;
  --mm-ocd-min-width: 200px;
  --mm-ocd-max-width: 440px;
}
.mm-ocd-opened {
  overflow-y: hidden;
  overscroll-behavior: none;
}
.mm-ocd {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 100%;
  left: 0;
  z-index: 9999;
  overflow: hidden;
  overscroll-behavior: contain;
  transition-property: bottom, background-color;
  transition-duration: 0s, 0.3s;
  transition-timing-function: ease;
  transition-delay: 0.45s, 0.15s;
}
.mm-ocd--open {
  bottom: 0;
  transition-delay: 0s;
}
.mm-ocd__content {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 2;
  width: 90%;
  width: var(--mm-ocd-width);
  min-width: 200px;
  min-width: var(--mm-ocd-min-width);
  max-width: 440px;
  max-width: var(--mm-ocd-max-width);
  transition-property: transform;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
.mm-ocd--left .mm-ocd__content {
  left: 0;
  transform: translate3d(-100%, 0, 0);
}
.mm-ocd--right .mm-ocd__content {
  right: 0;
  transform: translate3d(100%, 0, 0);
}
.mm-ocd--open .mm-ocd__content {
  transform: translate3d(0, 0, 0);
}
.mm-ocd__backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 3;
  width: calc(100% - 90%);
  width: calc(100% - var(--mm-ocd-width));
  min-width: calc(100% - 440px);
  min-width: calc(100% - var(--mm-ocd-max-width));
  max-width: calc(100% - 200px);
  max-width: calc(100% - var(--mm-ocd-min-width));
}
.mm-ocd--left .mm-ocd__backdrop {
  right: 0;
}
.mm-ocd--right .mm-ocd__backdrop {
  left: 0;
}
.mm-spn,
.mm-spn a,
.mm-spn li,
.mm-spn button,
.mm-spn ul {
  display: block;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
:root {
  --mm-spn-item-height: 50px;
  --mm-spn-item-indent: 20px;
  --mm-spn-line-height: 24px;
}
.mm-spn {
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: transparent;
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
  -webkit-clip-path: inset(0 0 0 0);
  clip-path: inset(0 0 0 0);
  transform: translateX(0);
}
.mm-spn ul {
  -webkit-overflow-scrolling: touch;
  position: fixed;
  top: 0;
  left: 100%;
  bottom: 0;
  z-index: 2;
  width: 130%;
  padding-right: 30%;
  line-height: 24px;
  line-height: var(--mm-spn-line-height);
  overflow: visible;
  overflow-y: auto;
  background: inherit;
  transition: left 0.3s ease 0s, visibility 0.3s linear;
  visibility: hidden;
  cursor: default;
}
.mm-spn ul:after {
  content: '';
  display: block;
  height: 50px;
  height: var(--mm-spn-item-height);
}
.mm-spn > ul {
  left: 0;
}
.mm-spn ul.mm-spn--open {
  left: 0;
  visibility: visible;
}
.mm-spn ul.mm-spn--parent {
  left: -30%;
  overflow-y: hidden;
  visibility: visible;
}
.mm-spn li {
  position: relative;
  background: inherit;
  cursor: pointer;
}
.mm-spn button:before {
  content: '';
  display: block;
  position: absolute;
  top: calc(50px / 2);
  top: calc(var(--mm-spn-item-height) / 2);
  right: calc(50px / 2);
  right: calc(var(--mm-spn-item-height) / 2);
  z-index: 0;
  width: 10px;
  height: 10px;
  border-top: 2px solid;
  border-right: 2px solid;
  transform: rotate(45deg) translate(0, -50%);
  opacity: 0.4;
}
.mm-spn li:after {
  content: '';
  display: block;
  margin-left: 20px;
  margin-left: var(--mm-spn-item-indent);
  border-top: 1px solid;
  opacity: 0.15;
}
.mm-spn a,
.mm-spn button {
  position: relative;
  z-index: 1;
  padding: calc((50px - 24px) / 2)
    20px;
  padding: calc((var(--mm-spn-item-height) - var(--mm-spn-line-height)) / 2)
    var(--mm-spn-item-indent);
}
.mm-spn a {
  background: inherit;
  color: inherit;
  text-decoration: none;
}
.mm-spn a:not(:last-child) {
  width: calc(100% - 50px);
  width: calc(100% - var(--mm-spn-item-height));
}
.mm-spn a:not(:last-child):after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: 1px solid;
  opacity: 0.15;
}
.mm-spn button {
  background: 0 0;
}
.mm-spn.mm-spn--navbar {
  cursor: pointer;
}
.mm-spn.mm-spn--navbar:before {
  content: '';
  display: block;
  position: absolute;
  top: calc(50px / 2);
  top: calc(var(--mm-spn-item-height) / 2);
  left: 20px;
  left: var(--mm-spn-item-indent);
  width: 10px;
  height: 10px;
  margin-top: 2px;
  border-top: 2px solid;
  border-left: 2px solid;
  transform: rotate(-45deg) translate(50%, -50%);
  opacity: 0.4;
}
.mm-spn.mm-spn--navbar.mm-spn--main {
  cursor: default;
}
.mm-spn.mm-spn--navbar.mm-spn--main > ul {
  visibility: visible;
}
.mm-spn.mm-spn--navbar.mm-spn--main:before {
  content: none;
  display: none;
}
.mm-spn.mm-spn--navbar:after {
  content: attr(data-mm-spn-title);
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  height: var(--mm-spn-item-height);
  padding: 0 calc(20px * 2);
  padding: 0 calc(var(--mm-spn-item-indent) * 2);
  line-height: 50px;
  line-height: var(--mm-spn-item-height);
  opacity: 0.4;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mm-spn.mm-spn--navbar.mm-spn--main:after {
  padding-left: 20px;
  padding-left: var(--mm-spn-item-indent);
}
.mm-spn.mm-spn--navbar ul {
  top: calc(50px + 1px);
  top: calc(var(--mm-spn-item-height) + 1px);
}
.mm-spn.mm-spn--navbar ul:before {
  content: '';
  display: block;
  position: fixed;
  top: inherit;
  z-index: 2;
  width: 100%;
  border-top: 1px solid currentColor;
  opacity: 0.15;
}
.mm-spn.mm-spn--vertical {
  overflow-y: auto;
}
.mm-spn.mm-spn--vertical ul {
  width: 100%;
  padding-right: 0;
  position: static;
}
.mm-spn.mm-spn--vertical ul ul {
  display: none;
  padding-left: 20px;
  padding-left: var(--mm-spn-item-indent);
}
.mm-spn.mm-spn--vertical ul ul:after {
  height: calc(50px / 2);
  height: calc(var(--mm-spn-item-height) / 2);
}
.mm-spn.mm-spn--vertical ul.mm-spn--open {
  display: block;
}
.mm-spn.mm-spn--vertical li.mm-spn--open:before {
  transform: rotate(135deg) translate(-50%, 0);
}
.mm-spn.mm-spn--vertical ul ul li:last-child:after {
  content: none;
  display: none;
}
/* 
* End pasted mmenu-light css.
* Begin custom overrides.
*/
.icon--house {
  margin-right: 0.5rem;
}
.mm-ocd {
  top: var(--spacing-21);
  z-index: 40;
}
.mm-spn.mm-spn--light {
  background-color: var(--brand-blueDark);
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--neutral-white);
}
.mm-spn a, .mm-spn button, .mm-spn.mm-spn--navbar:after {
  display: flex;
  width: 100%;
  padding: 1.25rem;
}
.mm-spn a:focus, .mm-spn a:focus-visible, .mm-spn a:active, .mm-spn button:focus, .mm-spn button:focus-visible, .mm-spn button:active {
  background-color: var(--brand-blue);
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.mm-spn li:after, .mm-spn.mm-spn--navbar ul:before {
  border-color: var(--brand-blueLight);
  opacity: 0.7;
}
.mm-spn li:after {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mm-spn li li:after {
  opacity: 0;
}
.mm-spn li li a, .mm-spn li li button {
  padding: 1rem;
}
.mm-spn button, .mm-spn li li button {
  padding-right: 3.5rem;
}
.mm-spn.mm-spn--navbar:after {
  display: block;
  height: 4rem;
  background-color: var(--brand-blue);
  padding-left: 3.5rem;
  text-align: left;
  font-weight: var(--fw-bold);
  line-height: 1.5;
  opacity: 1;
}
.mm-spn.mm-spn--navbar ul {
  top: 4rem;
}
.mm-spn button:before, .mm-spn.mm-spn--navbar:before {
  height: 1.5rem;
  width: 1.5rem;
  transform: none;
  border-width: 0px;
  opacity: 1;
}
.mm-spn button:before {
  top: calc(50% - 12px);
  content: url("data:image/svg+xml;charset=UTF-8, <svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 41 40' style='enable-background:new 0 0 41 40' xml:space='preserve'><path fill='white' d='M.5 20c0 4 1.2 7.8 3.4 11.1s5.3 5.9 9 7.4 7.7 1.9 11.6 1.1c3.9-.8 7.4-2.7 10.2-5.5 2.8-2.8 4.7-6.4 5.5-10.2.7-3.9.3-7.9-1.2-11.6-1.5-3.7-4.1-6.8-7.4-9C28.3 1.2 24.5 0 20.5 0 15.2 0 10.1 2.1 6.4 5.9 2.6 9.6.5 14.7.5 20zm37.1 0c0 3.4-1 6.7-2.9 9.5s-4.6 5-7.7 6.3c-3.1 1.3-6.6 1.6-9.9 1-3.3-.7-6.4-2.3-8.8-4.7-2.4-2.4-4-5.5-4.7-8.8s-.3-6.8 1-9.9C6 10.3 8.2 7.6 11 5.7c2.8-1.9 6.1-2.9 9.5-2.9 4.5 0 8.9 1.8 12.1 5 3.2 3.3 5 7.7 5 12.2z'/><path fill='white' d='m22.8 20.1-6.7 7 1.7 1.7 8.3-8.7-8.3-8.7-1.7 1.7 6.7 7z'/></svg>");
  z-index: 2;
}
.mm-spn.mm-spn--navbar:before {
  z-index: 10;
  top: 19px;
  content: url("data:image/svg+xml;charset=UTF-8, <svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 41 40' style='enable-background:new 0 0 41 40;transform:rotate(180deg)' xml:space='preserve'><path fill='white' d='M.5 20c0 4 1.2 7.8 3.4 11.1s5.3 5.9 9 7.4 7.7 1.9 11.6 1.1c3.9-.8 7.4-2.7 10.2-5.5 2.8-2.8 4.7-6.4 5.5-10.2.7-3.9.3-7.9-1.2-11.6-1.5-3.7-4.1-6.8-7.4-9C28.3 1.2 24.5 0 20.5 0 15.2 0 10.1 2.1 6.4 5.9 2.6 9.6.5 14.7.5 20zm37.1 0c0 3.4-1 6.7-2.9 9.5s-4.6 5-7.7 6.3c-3.1 1.3-6.6 1.6-9.9 1-3.3-.7-6.4-2.3-8.8-4.7-2.4-2.4-4-5.5-4.7-8.8s-.3-6.8 1-9.9C6 10.3 8.2 7.6 11 5.7c2.8-1.9 6.1-2.9 9.5-2.9 4.5 0 8.9 1.8 12.1 5 3.2 3.3 5 7.7 5 12.2z'/><path fill='white' d='m22.8 20.1-6.7 7 1.7 1.7 8.3-8.7-8.3-8.7-1.7 1.7 6.7 7z'/></svg>");
}
button {
  color: inherit;
  border: inherit;
  font-size: inherit;
  cursor: inherit;
}
`;